import { Injectable } from '@angular/core';
import {
  DataRouteParamModuleId,
  DataModuleEntityId,
  DataModuleEntity,
} from '@edgvr-front/data/domain';
import {
  createEffect,
  Actions,
  ofType,
  EffectNotification,
} from '@ngrx/effects';
import { getSelectors } from '@ngrx/router-store';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
  distinctUntilChanged,
  exhaustMap,
  filter,
  map,
  mergeMap,
  switchMap,
  takeUntil,
} from 'rxjs/operators';
import { DataModuleModulePageActions } from '../actions';
import { DataModuleGetRequestDTO } from '../dto';
import { DataService } from '../services';

const { selectRouteParams } = getSelectors();

@Injectable()
export class DataModuleModulePageEffects {
  dataModuleGet$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DataModuleModulePageActions.dataModuleGet),
      switchMap((_) =>
        this.dataService
          .dataModuleGet(new DataModuleGetRequestDTO({ id: _.id }))
          .pipe(
            mergeMap((_) => [
              DataModuleModulePageActions.dataModuleGetSuccess({
                dataModule: DataModuleEntity.factory(_.data.dataModule),
              }),
            ])
          )
      )
    )
  );

  selectedModuleSet$ = createEffect(() =>
    this.store.select(selectRouteParams).pipe(
      map((_) => Number(_[DataRouteParamModuleId]) as DataModuleEntityId),
      distinctUntilChanged(),
      filter((_) => Number.isSafeInteger(_)),
      mergeMap((_) => [
        DataModuleModulePageActions.selectedDataModuleSet({
          id: _,
        }),
        DataModuleModulePageActions.dataModuleGet({ id: _ }),
      ])
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly store: Store,
    private readonly dataService: DataService
  ) {}

  ngrxOnRunEffects(resolvedEffects$: Observable<EffectNotification>) {
    return this.actions$.pipe(
      ofType(DataModuleModulePageActions.start),
      exhaustMap(() =>
        resolvedEffects$.pipe(
          takeUntil(
            this.actions$.pipe(ofType(DataModuleModulePageActions.stop))
          )
        )
      )
    );
  }
}
